module.exports = __webpack_public_path__ + "img/multiLineTextEle.ef784d47.svg";